import { render } from "./ClosedDays.vue?vue&type=template&id=287d3cb6&scoped=true"
import script from "./ClosedDays.vue?vue&type=script&lang=js"
export * from "./ClosedDays.vue?vue&type=script&lang=js"

import "./ClosedDays.vue?vue&type=style&index=0&id=287d3cb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-287d3cb6"]])

export default __exports__